import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { NavItem } from '../../navbar/NavBarItems';
import './TableLayout.css';

interface TableLayoutProps {
  title: string;
  tabs: NavItem[];
}

export const TableLayout: React.FC<TableLayoutProps> = ({ title, tabs }) => {
  const location = useLocation();

  return (
    <div className="px-lg-5 px-0">
      <h2
        className="d-block d-lg-none text-secondary text-uppercase px-3 py-2"
        style={{ background: '#EFEFEF', fontSize: '1.5rem', fontWeight: 900 }}
      >
        {title}
      </h2>
      <h2
        className="d-none d-lg-block text-info fw-bold ps-2 pt-4"
        style={{ fontSize: '2.25rem' }}
      >
        {title}
      </h2>

      <Container fluid>
        {tabs.length > 0 && (
          <Nav
            className="table-layout my-2"
            activeKey={location.pathname}
            variant="underline"
          >
            {tabs
              .filter((t) => !t.hidden)
              .map((tab, idx: number) => (
                <Nav.Item key={idx}>
                  <Nav.Link
                    as={Link}
                    className="me-1 p-1"
                    to={tab.url ?? '#'}
                    href={tab.url ?? '#'}
                  >
                    {tab.title}
                  </Nav.Link>
                </Nav.Item>
              ))}
          </Nav>
        )}
        <Outlet />
      </Container>
    </div>
  );
};
